import React, { useContext } from 'react'
import { Container, Row, Card, Col, Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { ThemeContext } from '../components/ThemeContext.js'

// HomeScreen component
const HomeScreen = () => {
  const { theme } = useContext(ThemeContext)
  const navigate = useNavigate()
  return (
    <Container
      fluid='md'
      style={{ backgroundColor: theme.bg, color: theme.text }}
    >
      <Row>
        <Col className='my-2 p-2'>
          <Card
            className='my-2'
            style={{
              backgroundColor: theme.card,
              color: theme.text,
              borderColor: theme.sidebarAccent,
              borderRadius: '8px'
            }}
          >
            <Card.Body>
              <Card.Title>Our mission</Card.Title>
              <Card.Text>
                The elimination of all retail paper receipts via digitization.
              </Card.Text>
            </Card.Body>
            <Card.Footer
              style={{
                backgroundColor: theme.surfaceMuted,
                color: theme.subtext,
                borderColor: theme.sidebarAccent
              }}
            >
              <Button
                size='sm'
                variant='outline-primary'
                onClick={() => navigate('/about')}
                style={{
                  borderColor: theme.accent,
                  color: theme.accent,
                  backgroundColor: 'transparent',
                  border: `1px solid ${theme.accent}`
                }}
              >
                Learn More
              </Button>
            </Card.Footer>
          </Card>
          <Card
            className='my-2'
            style={{
              backgroundColor: theme.card,
              color: theme.text,
              borderColor: theme.sidebarAccent,
              borderRadius: '8px'
            }}
          >
            <Card.Body>
              <Card.Title>News</Card.Title>
              <Card.Text>
                May 2026 <br />
                <br />
                Call for investment and partnerships. Express interest at{' '}
                <a
                  href='https://www.hermanosgazpachos.ca'
                  target='_blank'
                  rel='noreferrer'
                  style={{ color: theme.accent }}
                >
                  hermanosgazpachos.ca
                </a>
                <br />
              </Card.Text>
            </Card.Body>
            <Card.Footer
              style={{
                backgroundColor: theme.surfaceMuted,
                color: theme.subtext,
                borderColor: theme.sidebarAccent
              }}
            >
              <Button
                size='sm'
                variant='outline-primary'
                href='mailto:info@hermanosgazpachos.ca'
                style={{
                  borderColor: theme.accent,
                  color: theme.accent,
                  backgroundColor: 'transparent',
                  border: `1px solid ${theme.accent}`
                }}
              >
                Contact Us
              </Button>
            </Card.Footer>
          </Card>
        </Col>

        <Col className='my-2 p-3'>
          <Card
            className='my-2'
            style={{
              backgroundColor: theme.card,
              color: theme.text,
              borderColor: theme.sidebarAccent,
              borderRadius: '8px'
            }}
          >
            <Card.Body>
              <Card.Title>Why go paperless?</Card.Title>
              <Card.Text>
                There are millions of tonnes of paper per year that end up in
                the waste/recycling stream, our assumption at a minimum is that
                three million tonnes are sales receipts.
                <br />
                <br />
                90% of receipts are coated in BPA or BPS, chemicals that are
                harmful to both humans and the environment. These chemicals can
                leach into the soil and waterways when disposed of, causing
                long-term environmental damage.
                <br />
                <br />
                By switching to electronic receipts, we can significantly reduce
                the demand for paper production, which in turn helps conserve
                natural resources, reduce energy consumption, and decrease
                greenhouse gas emissions associated with paper manufacturing.
                <br />
                <br />
                Our technology provides a private distributed ledger secured
                electronic receipt to you at checkout by scanning your unique QR
                code. It is easy to use, contactless and environmental.
              </Card.Text>
            </Card.Body>
            <Card.Footer
              style={{
                backgroundColor: theme.surfaceMuted,
                color: theme.subtext,
                borderColor: theme.sidebarAccent
              }}
            >
              <Button
                size='sm'
                variant='outline-primary'
                onClick={() => navigate('/businessregister')}
                style={{
                  borderColor: theme.accent,
                  color: theme.accent,
                  backgroundColor: 'transparent',
                  border: `1px solid ${theme.accent}`
                }}
              >
                Register Your Business
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default HomeScreen
